import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_URL, EMAIL_SUPPORT } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { COMPARE_CAPGO_FAQS } from '../../constants';

@Component({
  selector: 'app-compare-capgo-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './compare-capgo-faq-section.component.html',
  styleUrl: './compare-capgo-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCapgoFaqSectionComponent {
  protected readonly discordUrl = DISCORD_URL;
  protected readonly emailSupport = EMAIL_SUPPORT;
  protected readonly items = COMPARE_CAPGO_FAQS;
}
